import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Styles
import styles from './Spinner.styl';

const cx = classNames.bind(styles);

export default function Spinner(props) {
  const { className } = props;

  return <div className={cx('Spinner', className)} />;
}

Spinner.defaultProps = {
  className: '',
};

Spinner.propTypes = {
  className: PropTypes.string,
};
